import { Unternehmen } from '@/models/UnternehmenModels';

export type State = {
  unternehmen: Unternehmen;
  unternehmenliste: Array<Unternehmen>;
};

export const state: State = {
  unternehmen: sessionStorage.getItem('unternehmen') != null ? JSON.parse(sessionStorage.unternehmen) : new Unternehmen(),
  unternehmenliste: sessionStorage.getItem('unternehmenliste') != null ? JSON.parse(sessionStorage.unternehmenliste) : new Array<Unternehmen>(),
};
